// extracted by css-extract-rspack-plugin
export default {"grid":"_90216865","gridTablet":"_b444336f","gridDesktop":"_72a1d0f7","shimmerTitle":"_495f65f8","shimmerTitleMobile":"_f98b1e78"};